import { useEffect, useState } from 'react';
import { GOAL_STEPS, WEIGHT_UNIT } from '../../../../../types/enum';
import { convertWeight } from '../../../../../lib/utils';
import EndGoal from './endGoal';
import DailyWorkout from './dailyWorkout';
import DailyCalorie from './dailyCalorie';
import DailyPCF from './dailyPCF';
import Summary from './summary';
import usePreference from '../../../../../hook/usePreference';

const ResetGoal = ({ user, setResetGoal }) => {
  const { preference } = usePreference();

  const [currentStep, setCurrentStep] = useState(GOAL_STEPS.END_GOAL);
  const [goals, setGoals] = useState({
    workoutHours: 0,
    workoutDays: 0,
  });
  const [userDetail, setUserDetail] = useState({
    height: 0,
    weight: 0,
    gender: 0,
    birth: '',
  });

  useEffect(() => {
    const weight =
      preference.weightUnit === WEIGHT_UNIT.LB
        ? convertWeight(
            user.weightLogs[0]?.weight || user.weight,
            WEIGHT_UNIT.KG,
            WEIGHT_UNIT.LB
          )
        : user.weightLogs[0]?.weight || user.weight;

    setUserDetail({
      height: user.height,
      weight: Math.round(weight),
      gender: user.gender,
      birth: user.birth,
    });
  }, [user, preference]);

  return (
    <div className='mt-6 w-full max-w-sm mx-auto'>
      {currentStep === GOAL_STEPS.END_GOAL && (
        <EndGoal
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          preference={preference}
        />
      )}
      {currentStep === GOAL_STEPS.DAILY_WORKOUT && (
        <DailyWorkout
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
        />
      )}
      {currentStep === GOAL_STEPS.DAILY_CALORIE && (
        <DailyCalorie
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          userDetail={userDetail}
          preference={preference}
        />
      )}
      {currentStep === GOAL_STEPS.DAILY_PCF && (
        <DailyPCF
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          setResetGoal={setResetGoal}
        />
      )}
      {currentStep === GOAL_STEPS.SUMMARY && (
        <Summary
          goals={goals}
          setGoals={setGoals}
          setCurrentStep={setCurrentStep}
          userDetail={userDetail}
          setResetGoal={setResetGoal}
          preference={preference}
        />
      )}
    </div>
  );
};

export default ResetGoal;
